export const no = {
    'nav.today': "Oversikt I Dag",
    'nav.calendar': "Etterspørselskalender",
    'nav.rates': "Priser og Regler",
    'nav.automation': "Automatiseringssenter",
    'nav.audit': "Revisjonslogg",
    'nav.settings': "Innstillinger",
    'sidebar.status': "Tilkoblet",
    'stat.occupancy': "Belegg",
    'stat.adr': "Snittpris (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Est. Inntekt",
    'stat.trend.vsLastWeek': "vs Forrige Uke",
    'stat.trend.onPace': "I rute",
    'dashboard.actions.title': "Anbefalte Handlinger",
    'dashboard.actions.empty': "Ingen handlinger funnet.",
    'filter.all': "Alle",
    'filter.pricing': "Prising",
    'filter.restriction': "Restriksjoner",
    'action.approve': "Godkjenn",
    'action.reject': "Avvis",
    'action.risk.low': "lav risiko",
    'action.risk.medium': "middels risiko",
    'action.risk.high': "høy risiko",
    'action.label.current': "Nåværende",
    'action.label.proposed': "Foreslått",
    'action.metric.impact': "Effekt",
    'action.metric.why': "Hvorfor",
    'action.status.executed': "Auto-Utført",
    'header.search': "Søk...",
    'header.logout': "Logg ut",
    'auto.level.title': "Autopilotnivå",
    'auto.level.manual': "Manuell",
    'auto.level.manual.desc': "Du godkjenner hver anbefaling.",
    'auto.level.assisted': "Assistert",
    'auto.level.assisted.desc': "Auto-godkjenn lav risiko. Se over store endringer.",
    'auto.level.auto': "Fullautomatisk",
    'auto.level.auto.desc': "AI styrer priser 24/7 innenfor dine grenser.",
    'auto.level.active': "Aktiv",
    'auto.guardrails.title': "Sikkerhetsgrenser",
    'auto.guardrails.maxIncrease': "Maks Daglig Økning",
    'auto.guardrails.maxIncrease.desc': "Unngå prissjokk.",
    'auto.guardrails.maxDecrease': "Maks Daglig Nedgang",
    'auto.guardrails.maxDecrease.desc': "Unngå prisdumping.",
    'auto.guardrails.minRate': "Minimumspris",
    'auto.guardrails.minRate.desc': "Selg aldri under denne prisen (Netto).",
    'auto.emergency.title': "Nødkontroll",
    'auto.emergency.label': "Nødstopp",
    'auto.emergency.desc': "Sett all automatisering på pause umiddelbart.",
    'auto.emergency.btn': "PAUSE SYSTEM",
    'rates.filter.all': "Alle Romtyper",
    'rates.filter.next14': "Neste 14 Dager",
    'rates.export': "Eksporter",
    'audit.table.time': "Tid",
    'audit.table.actor': "Bruker",
    'audit.table.category': "Kategori",
    'audit.table.action': "Handling",
    'audit.table.details': "Detaljer",
    'audit.table.status': "Status",
    'settings.pms.title': "PMS Tilkobling",
    'settings.pms.connected': "Tilkoblet til",
    'settings.pms.disconnect': "Koble fra",
    'settings.account.title': "Konto",
    'settings.account.role': "Rolle",
    'settings.restart': "Start Onboarding På Nytt",
    'onboard.title': "Koble til PMS",
    'onboard.desc': "Velg ditt PMS for synkronisering.",
    'onboard.connecting': "Kobler til...",
    'onboard.connect': "Koble til",
    'onboard.success.title': "Oppsett Ferdig!",
    'onboard.success.desc': "**SynthHotel Berlin** er nå synkronisert.",
    'onboard.success.sub': "Importerte 3 romtyper, 14 prisplaner og 243 bookinger.",
    'onboard.btn.dashboard': "Gå til Dashboard",
    'action.dynamic.weekend.title': "Øk Pris for Helg",
    'action.dynamic.weekend.desc': "Belegg > 75% Lørdag, sterk etterspørsel (+12 rom på 24t).",
    'action.dynamic.minstay.title': "Aktiver Min. Opphold 2 Netter",
    'action.dynamic.minstay.desc': "Taylor Swift konsert. Forhindre 1-natt opphold.",
    'action.dynamic.distress.title': "Senk Pris (Lav Etterspørsel)",
    'action.dynamic.distress.desc': "Belegg 35% neste Tirsdag. Konkurrenter senket 10€.",
    'action.dynamic.gap.title': "Fyll Hull: Fjern CTA",
    'action.dynamic.gap.desc': "Hull på én natt. Fjern 'Stengt for Ankomst' for å selge.",
};
